import colors from './colors'

const theme = {
  palette: colors
}

export { theme }
